module.exports = __webpack_public_path__ + "static/media/call.172d5986.svg";